/*eslint-disable*/
import React from "react";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import DatePicker from "components/Wrappers/materialUIWrappers/components/DatePicker";
import { Field } from "redux-form";
import {
  Card,
  Grid,
  FormControl,
  CardContent,
  CardHeader,
  withStyles
} from "@material-ui/core";

const required = value => (value ? undefined : "Required");

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const styles = () => ({});

class CC_willDetail extends React.Component {
  componentDidMount(){
    this.props.scrollMeBar();
  }
  render() {
    const validate = [];
    validate.push(required);

    return (
      <Card className="contentWithStepper">
        <CardHeader title="Client Will detail" />
        <CardContent>
        <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  component={FormDropdown}
                  checkValidation={this.props.checkValidation}
                  label="Does the client have a will?"
                  name="willHasWill"
                  options={[
                    {
                      value: "validationError",
                      displayValue: "Please select"
                    },
                    { value: "Y", displayValue: "Yes" },
                    { value: "N", displayValue: "No" }     
                  ]}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"willExcecutor"}
                  component={FormInput}
                  label={"Who is the excecutor?"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"willLocation"}
                  component={FormInput}
                  label={"Where does the client keep their will?"}
                />
              </FormControl>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(CC_willDetail);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_willDetail.jsx